<div class="controls" *ngIf="processListStatus !== 'finished'">

  <ng-container *ngIf="!(isSmallScreen$ | async)">
    <span class="mat-title">Candidatos Selecionados</span>

    <button mat-raised-button color="primary" (click)="finishProcess()" *ngIf="processListStatus !== 'finished'"
      style="float: right; margin-bottom: 1%">
      Encerrar processo seletivo
    </button>
  </ng-container>
  <ng-container *ngIf="candidateMode === 'default'">
    <div class="row">
      <button mat-stroked-button color="primary" (click)="candidateMode = 'contract'">Contratar candidato</button>
      <button mat-stroked-button color="primary" [matMenuTriggerFor]="matMenu">
        Opções
        <mat-icon>more_vert</mat-icon>
    </button>
    </div>
  </ng-container>

  <ng-container *ngIf="candidateMode === 'contract'">
    <div class="row">
      <button mat-stroked-button color="accent" (click)="candidateMode = 'default'">
        Cancelar
      </button>
      <button mat-stroked-button color="primary" (click)="hireCandidates()">
        Contratar
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="candidateMode === 'test'">
      <div class="row">
        <button mat-stroked-button color="accent" (click)="candidateMode = 'default'">Cancelar</button>
        <button mat-raised-button [color]="areAllCandidatesSelected ? 'warn' : 'primary'" (click)="toggleSelectCandidates()"
            [disabled]="candidates.length === 0"> {{ areAllCandidatesSelected ? 'Deselecionar todos candidatos' : 'Selecionar todos candidatos' }}
          </button>
        <button mat-stroked-button color="primary" (click)="openMultipleSelectionTest()"
            [disabled]="candidates.length === 0">Selecionar testes</button>
      </div>
  </ng-container>

</div>

<mat-action-list *ngIf="candidateMode === 'default'">
  <ng-container *ngFor="let candidate of candidates">
    <button mat-list-item>
      <mat-icon matListIcon *ngIf="candidate.avatar_profile === null">account_circle</mat-icon>
      <img [src]="mediaEndpoint + candidate.avatar_profile" matListAvatar *ngIf="candidate.avatar_profile" />

      <h3 (click)="openCandidate(candidate)" matLine>
        {{ candidate.firstname }} {{ candidate.lastname }}
      </h3>
      <p (click)="openCandidate(candidate)" matLine>{{ candidate.city }}</p>

      <ng-container *ngIf="!(isSmallScreen$ | async) && currentProcessList.status !== 'finished'">
        <mat-icon *ngIf="candidate.candidateStatus === 'hired'" style="color:#093"
          matTooltip="Contratado">how_to_reg</mat-icon>
        <span class="score mat-title" matTooltip="Pontuação do candidato">
          <mat-icon color="accent">emoji_events</mat-icon>
          {{ candidate.total_score }}
        </span>
        <!-- <button mat-icon-button color="primary" [matTooltip]="'Palavras Chaves: '+candidate.keywords" (click)="snackMessage(candidate.keywords)">
          <mat-icon>tune</mat-icon>
        </button> -->
        <button mat-icon-button color="primary" (click)="openProfessionalExperiences(candidate)"
          matTooltip="Ver histórico profissional">
          <mat-icon>business_center</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="openCandidateComment(candidate)"
          matTooltip="Adicionar observação">
          <mat-icon>draw</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="openPoints(candidate)" matTooltip="Pontuar candidato">
          <mat-icon>timeline</mat-icon>
        </button>
        <button mat-icon-button color="primary" class="interview" matTooltip="Ver entrevista"
            matBadge="{{ candidate.accept_interview && alertInterview[candidate.id] ? '!' : '' }}" 
            matBadgeColor="accent"
            [ngClass]="{'active-badge': candidate.accept_interview >= 0 && alertInterview[candidate.id]}" 
            (click)="openInterviewEvaluated(candidate)">
            <mat-icon>assignment_ind</mat-icon>
        </button>
        <button color="primary" class="interview" mat-icon-button (click)="openSelectionTest(candidate)"
            matBadge="{{ candidate.responses_total > 0 && alertTestview[candidate.id] ? '!' : '' }}" 
            matBadgeColor="accent"
            [ngClass]="{'active-badge': candidate.responses_total > 0 && alertTestview[candidate.id]}"    
            matTooltip="Escolher questões para o candidato">
            <mat-icon>live_help</mat-icon>
        </button>
        <button color="warn" mat-icon-button (click)="deleteLead(candidate)"
          matTooltip="Remover candidato do processo seletivo">
          <mat-icon>delete</mat-icon>
        </button>
      </ng-container>


      <ng-container *ngIf="isSmallScreen$ | async">
        <button mat-icon-button color="primary" [matMenuTriggerFor]="candidateOptionsMenu">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #candidateOptionsMenu="matMenu">
          <button mat-menu-item (click)="openPoints(candidate)">
            <mat-icon>insights</mat-icon>
            Pontuação do candidato
          </button>
          <ng-container *ngIf="currentProcessList.status !== 'finished'">
            <button mat-icon-button color="primary" matTooltip="Ver entrevista"
                matBadge="{{ candidate.accept_interview >= 0 && alertInterview ? '!' : '' }}" 
                matBadgeColor="accent"
                [ngClass]="{'active-badge': candidate.accept_interview >= 0 && alertInterview}" 
                (click)="openInterviewEvaluated(candidate)">
                <mat-icon>assignment_ind</mat-icon>
            </button>
            <button color="primary" mat-icon-button (click)="openSelectionTest(candidate)"
                matBadge="{{ candidate.responses_total > 0 && alertTestview ? '!' : '' }}" 
                matBadgeColor="accent"
                [ngClass]="{'active-badge': candidate.responses_total > 0 && alertTestview}"    
                matTooltip="Escolher questões para o candidato">
                <mat-icon>live_help</mat-icon>
            </button>
            <button mat-menu-item (click)="deleteLead(candidate)" style="color: red">
              <mat-icon>delete</mat-icon>
              Remover candidato
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </button>
  </ng-container>
</mat-action-list>

<ng-container *ngIf="candidates?.length === 0">
  <div class="empty-content">
    <span class="mat-body-2" style="text-align: center;">
      <p>Nenhum candidato encontrado</p>
      <!-- <p>OBS: Pesquise os candidatos usando o filtro ao lado. Em seguida, selecione os candidatos desejados <br>e clique
        em "Continuar processo seletivo".</p> -->
    </span>
  </div>
</ng-container>

<mat-selection-list *ngIf="candidateMode === 'contract'" #candidatesForHire>
  <ng-container *ngFor="let candidate of candidates">
    <mat-list-option [value]="candidate.id">
      <h3 matLine>{{ candidate.firstname }} {{ candidate.lastname }}</h3>
      <p matLine>{{ candidate.city }}</p>
      <span matLine *ngIf="candidate.candidateStatus === 'hired'" style="color: #093">Já contratado</span>
    </mat-list-option>
  </ng-container>
</mat-selection-list>

<mat-selection-list *ngIf="candidateMode === 'test'" #selectCandidatesForTest>
  <ng-container *ngFor="let candidate of candidates">
      <mat-list-option [value]="candidate.id">
          <h3 matLine>{{ candidate.firstname }} {{ candidate.lastname }}</h3>
          <p matLine>{{ candidate.city }}</p>
          <span matLine *ngIf="candidate.candidateStatus === 'hired'" style="color: #093">Já contratado</span>
      </mat-list-option>
  </ng-container>
</mat-selection-list>


<div>
  <mat-paginator *ngIf="candidates.length > 0" (page)="pageEvent($event)" [length]="totalLeads" [pageSize]="20"
    [pageSizeOptions]="[20, 50, 100]">
  </mat-paginator>
</div>

<mat-menu #matMenu="matMenu">
  <button mat-menu-item (click)="openNewTest()">Cadastrar Teste</button>
  <button mat-menu-item (click)="candidateMode = 'test'">Aplicar Testes</button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="openInterview()">Cadastrar entrevista</button>
  <button mat-menu-item (click)="openInterviewSession()">Chamar para entrevista</button>
</mat-menu>